<template>
	<div v-if="this.$checkStatusResponse(this.status)">
		<section>
			<div class="container col-lg-11 mt-5">
				<card noBody type="secondary" style="margin-top: 150px;">
					<div class="container">
						<div class="pl-0">
							<div class="row row-grid align-items">
								<div class="col-sm-3">
									<h3 class="text-center text-dark mt-4 mb-0"><strong>Transaction</strong></h3>
								</div>
								<div class="col-sm-5">
									<h6 class="text-muted float-center text-truncate mt-4 mb-4 py-2">{{this.$route.params.txHash}}</h6>
								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items ">
					<card class="border-0" type="teal" noBody>
						<div class="pl-0">
							<div class="container">
								<div class="row row-grid align-items">
									<div class="col-lg-6">
										<img src="../assets/icons/bars.png" align="left" style="width: 15px; padding-top: 6px;">
										<h6 class="text-white text-uppercase mb-1 px-4 text-left mt-1">Transaction information</h6>
									</div>
								</div>
							</div>
						</div>
					</card>
				</div>

				<div class="order-lg-2 align-items mt-2 mb-4">
					<card type="secondary">
						<dl class="row">
							<dt class="col-md-3 col-sm-3">TxHash:</dt>
							<dd class="col-md-9 col-sm-9 text-truncate">{{txDetail.transaction.hash}}</dd>
							<dt class="col-md-3 col-sm-3">TxReceipt Status:</dt>
							<dd class="col-md-9 col-sm-9" v-if="txDetail.status === '0x1'">
								<h6 class="text-success">
									<strong>Success</strong>
								</h6>
							</dd>
							<dd class="col-md-9 col-sm-9" v-else-if="txDetail.status === '0x0'">
								<h6 class="text-warning">
									<strong>Error</strong>
								</h6>
							</dd>
							<dd class="col-md-9 col-sm-9" v-else>
							</dd>
							<dt class="col-md-3 col-sm-3">From:</dt>
							<dd class="col-md-9 col-sm-9">
								<router-link :to="'/address/' + txDetail.transaction.from">
									<p class="text-info mb-0 text-truncate">{{txDetail.transaction.from}}</p>
								</router-link>
							</dd>
							<dt class="col-md-3 col-sm-3">To:</dt>
							<dd class="col-md-9 col-sm-9">
								<router-link :to="'/address/' + txDetail.transaction.to">
									<p class="text-info text-truncate mb-0">{{txDetail.transaction.to}}</p>
								</router-link>
							</dd>
							<dt class="col-md-3 col-sm-3">Value:</dt>
							<dd class="col-md-9 col-sm-9">{{$globalConverter(txDetail.transaction.value)}}</dd>
							<dt class="col-md-3 col-sm-3">Gas Limit:</dt>
							<dd class="col-md-9 col-sm-9">{{txDetail.transaction.gas}}</dd>
							<dt class="col-md-3 col-sm-3">Gas Used By Txn:</dt>
							<dd class="col-md-9 col-sm-9">{{txDetail.gasUsed}}</dd>
							<dt class="col-md-3 col-sm-3">Gas Price:</dt>
							<dd class="col-md-9 col-sm-9">{{txDetail.transaction.gasPrice}}</dd>
							<dt class="col-md-3 col-sm-3">Nonce:</dt>
							<dd class="col-md-9 col-sm-9">{{txDetail.transaction.nonce}}</dd>
							<dt class="col-md-3 col-sm-3">Input Data:</dt>
							<dd class="col-md-9 col-sm-9">
								<form action="">
									<textarea name="InputData" id="textAreaInputData" class="form-control" :placeholder="txDetail.transaction.input" disabled></textarea>
								</form>
							</dd>
						</dl>
					</card>
				</div>
			</div>
		</section>
	</div>
	<div v-else>
		<section>
			<div class="container col-lg-11 mt-5">
				<card noBody type="secondary" style="margin-top: 150px;">
					<div class="container">
						<div class="pl-0">
							<div class="row row-grid align-items">
								<div class="col-sm-3">
									<h3 class="text-dark text-left mt-4 mb-4"><strong>Transaction</strong></h3>
								</div>
								<div class="col-sm-5">
									<h6 class="text-muted text-left float-center text-truncate">{{this.$route.params.txHash}}</h6>
								</div>
								<div class="col-md-4"></div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items ">
					<card class="border-0" type="teal" noBody>
						<div class="pl-0">
							<div class="container">
								<div class="row row-grid align-items">
									<div class="col-lg-6">
										<img src="../assets/icons/bars.png" align="left" style="width: 15px; padding-top: 6px;">
										<h6 class="text-white text-uppercase mb-1 px-4 text-left mt-1">Transaction information</h6>
									</div>
								</div>
							</div>
						</div>
					</card>
				</div>

				<div class="order-lg-2 align-items mt-2 mb-4">
					<card type="secondary">
						<h6 class="text-warning text-center">There are not marching entries</h6>
					</card>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
  data () {
    return {
      status: {},
      txDetail: {
        transaction: {
          hash: ''
        }
      }
    }
  },
  mounted () {
    this.$http
      .get('get-tx-detail/' + this.$route.params.txHash)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.txDetail = data
      }, response => {
        this.status = response.status
      })
  },
  watch: {
    '$route.params.txHash': function () {
      this.txDetail = {
        transaction: {
          hash: ''
        }
      }
      this.$http
        .get('get-tx-detail/' + this.$route.params.txHash)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.txDetail = data
        }, response => {
          this.status = response.status
        })
    }
  }
}
</script>

<style>
</style>
